import DatePicker from 'components/DatePicker'
import type { DatePickerProps } from 'components/DatePicker'
import styled from 'styled-components'

const StyledDatePicker = styled(DatePicker)<DatePickerProps>`
  margin-top: 0.625rem;

  input {
    line-height: 1.5rem;
    height: auto;
    padding: 0.3rem 1rem;
  }
`

export default StyledDatePicker
